module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_4-3daa016a77d65bd59637f526080a7ffc.jpg";